import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface PendingIncomeActionsProps {
    disabled: boolean;
    hasSelection: boolean;
    onAccept: () => void;
    onReject: () => void;
}

const PendingIncomeActions = ({ disabled, hasSelection, onAccept, onReject }: PendingIncomeActionsProps) => {
    const { t } = useTranslation(['Warehouses']);
    const locked = disabled || !hasSelection;

    return (
        <div className="d-flex justify-content-end gap-2 mt-2">
            <Button variant="primary" size="sm" disabled={locked} onClick={onAccept}>
                {t('pendingIncome.acceptChecked')}
            </Button>
            <Button variant="outline-danger" size="sm" disabled={locked} onClick={onReject}>
                {t('pendingIncome.rejectChecked')}
            </Button>
        </div>
    );
};

export default PendingIncomeActions;
